'use client';

import React, { FC, useState } from 'react';

import Image from 'next/image';

import { Entry } from 'contentful';

import { Modal } from '@/components';

import { TypeDynamicInfoModalFields } from '@/core/generated-types';

import checkMarkBlue from '@/public/assets/images/checkmark-icon-blue.png';

type DynamicInfoModalProps = {
  dynamicInfoModal?: Entry<TypeDynamicInfoModalFields>;
};

export const DynamicInfoModal: FC<DynamicInfoModalProps> = ({
  dynamicInfoModal,
}) => {
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  if (!dynamicInfoModal) return;

  return (
    <div className="flex justify-end" data-testid="dynamic-info-modal">
      <button
        className="text-sm lg:text-base text-blue-deep [&_span]:font-bradford [&_span]:font-medium"
        onClick={() => {
          setInfoModalOpen(true);
        }}
        data-testid="dynamic-info-modal-cta"
        dangerouslySetInnerHTML={{
          __html: dynamicInfoModal.fields.cta,
        }}
      />
      <Modal
        modalClasses={{
          mobile: {
            padding: '16px 16px 35px',
            borderRadius: '6px',
          },
          desktop: {
            padding: '32px',
            borderRadius: '6px',
          },
        }}
        contentClasses="grid gap-y-2.5 md:gap-y-4"
        isOpen={infoModalOpen}
        handleClose={() => {
          setInfoModalOpen(false);
        }}
      >
        <p
          className="text-2xl font-bold text-charcoal-v2"
          data-testid="dynamic-info-modal-title"
        >
          {dynamicInfoModal.fields.title}
        </p>
        <ul
          className="grid gap-y-6"
          data-testid="dynamic-info-modal-list-items"
        >
          {dynamicInfoModal.fields.listItems.map((listItem, i) => (
            <li
              key={`list-item-${i}`}
              className="flex items-start gap-x-3 md:gap-x-5"
            >
              <Image
                className="h-6 mt-1 ml-2.5 md:ml-0"
                width={24}
                height={24}
                src={checkMarkBlue}
                alt="check-mark"
              />
              <span>{listItem}</span>
            </li>
          ))}
        </ul>
      </Modal>
    </div>
  );
};
